module.exports = __webpack_public_path__ + "static/media/account.234298fb.svg";